import React from "react";
import ReactLoading from 'react-loading'

const Loading = ({size = -1, color="#34AED4", containerHeight = '100svh'}) => {
    return <div style={{display: 'flex', height: {containerHeight}, alignItems: 'center', justifyContent: 'center', width:'100%'}}>
        <ReactLoading color={color} type="spinningBubbles" height={size === -1?undefined: size} width={size === -1?undefined: size} ></ReactLoading>
        </div>
}

export default Loading